import { AdministrationComponent } from './administration.component';
import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { EmailContentComponent } from './components/email-content.component';
import { AlertContentComponent, ApplicationTypes, EdlPortalSettingsComponent, EdlTemplateTypesService, PortalService, SessionService, UserDirectoryService } from '@edl-development/edl-common';
import { TokenAdminListComponent } from './components/token-admin/token-admin-list/token-admin-list.component';
import { AdministrationLazyLoadedStates } from '../lazy-loaded-states/administration.lazy-loaded-states';
import { firstValueFrom } from 'rxjs';
import { GroupService } from '../services/group.service';
import { TokenManagementFormComponent } from './components/token-admin/token-admin-form/token-admin-form.component';
import { EdlTemplateTypesManagementComponent } from './components/edl-template-types/edl-template-types-management/edl-template-types-management.component';

export function resolveProtalInfo(portalService: PortalService) {
    return portalService
        .getPortalInfo()
        .toPromise();
}

export function resolvePortalSettings(portalService: PortalService, sessionService: SessionService) {
    const portalID = sessionService.user.UserPortal != undefined ? sessionService.user.UserPortal.PortalID : 1;
    return portalService
        .getPortalSettings(portalID, true)
        .toPromise();
}

export function resolvePortals(portalService: PortalService) {
    return portalService
        .getPortals()
        .toPromise();
}

export function resolvePortalTokens(portalService: PortalService) {
  return portalService
      .getPortalsTokens(ApplicationTypes.EDL_COMPLY)
      .toPromise();
}


export function resolveGroupsByPortal(groupService: GroupService) {

  return groupService
      .getAllGroupsForPortal()
      .toPromise();
}

export function resolveSearchCriteria(sessionService: SessionService, userDirectoryService: UserDirectoryService) {
  let user = sessionService.user;
  return userDirectoryService
      .getSearchCriteria(user.UserPortal.PortalID).toPromise();
}


export function resolvePortalToken(portalService: PortalService, transition: Transition) {
  const { tokenid } = transition.params();
  return firstValueFrom(portalService.getPortalToken(tokenid));
}




export let AdministrationStates: Ng2StateDeclaration[] = [{
    ...AdministrationLazyLoadedStates.statesMap.base,
    views: {
        'content@authenticated': {
            component: AdministrationComponent
        }
    },
    resolve: [{
        token: 'portalInfo',
        deps: [PortalService],
        resolveFn: resolveProtalInfo
    }]
},
{
    ...AdministrationLazyLoadedStates.statesMap.settings,
    views: {
        'content@authenticated': {
            component: EdlPortalSettingsComponent
        }
    },
    resolve: [{
        token: 'portalSettings',
        deps: [PortalService, SessionService],
        resolveFn: resolvePortalSettings
    },{
        token: 'portalList',
        deps: [PortalService],
        resolveFn: resolvePortals
    }, {
        token: 'templateTypes',
        deps: [EdlTemplateTypesService],
        resolveFn: (edlTemplateTypesService: EdlTemplateTypesService) => firstValueFrom(edlTemplateTypesService.getAll())
    }, {
        token: 'onCloseState',
        resolveFn: () => 'authenticated.administration'
    }]
},
{
    ...AdministrationLazyLoadedStates.statesMap.emailContent,
    views: {
        'content@authenticated': {
            component: EmailContentComponent
        }
    }
},
{
    ...AdministrationLazyLoadedStates.statesMap.alert,
    views: {
        'content@authenticated': {
            component: AlertContentComponent
        }
    }
},
{
    ...AdministrationLazyLoadedStates.statesMap.token_list,
  views: {
      'content@authenticated': {
          component: TokenAdminListComponent
      }
  },
  resolve: [{
      token: 'tokens',
      deps: [PortalService, SessionService],
      resolveFn: resolvePortalTokens
  }]
},

{
  ...AdministrationLazyLoadedStates.statesMap.token_add,
  views: {
      'content@authenticated': {
          component: TokenManagementFormComponent
      }
  },
  resolve: [{
      token: 'groups',
      deps: [GroupService],
      resolveFn: resolveGroupsByPortal
  },
  {
    token: 'searchCriteria',
    deps: [SessionService, UserDirectoryService],
    resolveFn: resolveSearchCriteria
  }]
},

{
  ...AdministrationLazyLoadedStates.statesMap.token_edit,
  views: {
      'content@authenticated': {
          component: TokenManagementFormComponent
      }
  },
  resolve: [{
    token: 'token',
    deps: [PortalService, Transition],
    resolveFn: resolvePortalToken
  },
  {
    token: 'searchCriteria',
    deps: [SessionService, UserDirectoryService],
    resolveFn: resolveSearchCriteria
  }]
}, 
{
    ...AdministrationLazyLoadedStates.statesMap.edl_template_types,
    views: {
        'content@authenticated': {
            component: EdlTemplateTypesManagementComponent
        }
    },
    resolve: [{
        token: 'edlTemplateTypes',
        deps: [EdlTemplateTypesService],
        resolveFn: (edlTemplateTypesService: EdlTemplateTypesService) => firstValueFrom(edlTemplateTypesService.getAll())
    }]
},

// FUTURE STATES
...AdministrationLazyLoadedStates.generateChildrenLazyLoadedStates()
];